package com.example.readingnotes.domain.model

data class User(
    val id: Int,
    val username: String,
    val role: UserRole,
    val totpEnabled: Boolean,
)
